import React, { ReactNode, createContext, useContext, FC, useMemo } from 'react';
import pick from 'lodash/pick';

import { INotificationsRequestDTO } from 'src/api/dtos';
import { defaultNotificationsQueryParams } from 'src/features/message-center/MessageCenter.utils';
import { useQuery } from 'src/shared/hooks';
import { parseQuery } from 'src/shared/utils';

type MessageCenterQueryProps = {
  filters: INotificationsRequestDTO;
};

const MessageCenterQueryContext = createContext<MessageCenterQueryProps>({} as MessageCenterQueryProps);

export const useMessageCenterQuery = (): MessageCenterQueryProps =>
  useContext<MessageCenterQueryProps>(MessageCenterQueryContext);

export const MessageCenterQueryProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const query = useQuery();

  const filters = useMemo<INotificationsRequestDTO>(() => {
    const q = query
      ? pick(parseQuery(query.toString()), ['mailboxFolder', 'sortBy', 'sortDirection', 'searchTerm'])
      : {};
    return {
      ...defaultNotificationsQueryParams,
      ...q,
    };
  }, [query]);

  return <MessageCenterQueryContext.Provider value={{ filters }}>{children}</MessageCenterQueryContext.Provider>;
};
